import classes from './TitleHeader.module.css';

interface Props {
    headerText: string
}

const TitleHeader = ({ headerText }: Props) => {
    return (
        <div className={classes.titleHeader}>
            {headerText}
        </div>
    )
};

export default TitleHeader;